module.exports = __webpack_public_path__ + "static/media/assistance-24-7.2855a2dd.svg";